/**
 * Users API Queries
 *
 * Query keys and read operations.
 */

// API client
import { apiClient } from '../client';
import { createResourceListQueryKeys } from '../resourceListPage/queryKeys';

// Types
import type { FetchUsersParams, User, UserResponse, UsersResponse } from './types';

export const usersQueryKeys = createResourceListQueryKeys<FetchUsersParams>('users');

export async function getUsers({ roles, ...params }: FetchUsersParams = {}): Promise<UsersResponse> {
  const { data } = await apiClient.get<UsersResponse>('/api/users', {
    params: { ...params, role: roles?.length ? roles : undefined },
  });
  return data;
}

export async function getUser(id: number): Promise<User> {
  const { data } = await apiClient.get<UserResponse>(`/api/users/${id}`);
  return data.user;
}
